import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import  rootReducer  from './store/reducers/rootReducer'
import {createStore,applyMiddleware ,compose} from 'redux'
import { Provider} from 'react-redux'
import thunk from 'redux-thunk';
import {getFirebase , reactReduxFirebase} from 'react-redux-firebase';
import  {getFirestore , reduxFirestore} from 'redux-firestore'
import fbConfig from './config/fbConfig'

const store = createStore(rootReducer,
    compose( applyMiddleware(thunk.withExtraArgument({getFirebase,getFirestore})),
        reactReduxFirebase(fbConfig,{ attachAuthIsReady : true, useFirestoreForProfile :true ,userProfile:'users'  }),
        reduxFirestore(fbConfig)

    ));

store.firebaseAuthIsReady.then(()=>{
    ReactDOM.render( <Provider  store={store}><App /></Provider>, document.getElementById('root'));
    serviceWorker.unregister();

});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
